import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';
import { CollaboratoreDTO } from '../domain/collaboratore';
import { SoftwareDTO } from './software';
import { DeviceTypeDTO } from './deviceType';

export class DeviceDTO extends LogicalDeleteDTO {     //stesse cose e nomi del DTO del backend
    
    id: number;
    fattura: number;
    collaboratore: CollaboratoreDTO;
    tipo: DeviceTypeDTO;
    codiceCespite: string;
    mac: string;
    serie: string;
    dataConsegna: Date;
    dataRiconsegna: Date;
    formattato: Boolean;
    software: SoftwareDTO[];
    
}